import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import autoBind from "react-autobind";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input, Checkbox } from "formsy-react-components";

import * as modalActions from "../../../actions/modalActions";

class CallPartsForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      canSubmit: false
    };

    autoBind(this);
  }

  add = (part) => {
    this.props.onAdd(part);
  };

  submit = (part) => {
    this.props.onSave(part);
  };

  cancel = () => {
    this.props.onCancel();
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { part, adding } = this.props;
    // console.log(part);
    return (
      <Formsy
        // eslint-disable-next-line react/no-string-refs
        ref="form"
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={4}>
            <Input
              formNoValidate
              required
              name="item_description"
              label="Description"
              value={part.item_description}
              validations={{ maxLength: 250 }}
              validationErrors={{
                maxLength: "You can not type in more than 250 characters"
              }}
            />
          </Col>
          <Col md={3}>
            <Input
              type="number"
              formNoValidate
              required
              name="item_qty"
              label="Quantity"
              value={part.item_qty}
            />
          </Col>
          <Col md={3}>
            <Input
              type="number"
              formNoValidate
              required
              name="item_cost"
              label="Cost"
              value={part.item_cost}
            />
          </Col>
          <Col md={2}>
            <Checkbox
              formNoValidate
              name="item_bill"
              valueLabel="Billable"
              value={part.item_bill}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="footer">
            <button
              className="btn  btn-cancel"
              type="button"
              onClick={this.cancel}
            >
              Cancel
            </button>
            <input
              className="btn  btn-success"
              type="submit"
              disabled={!this.state.canSubmit || this.props.saving}
              value={this.props.saving ? "Saving... " : "Save"}
            />
          </Col>
        </Row>
      </Formsy>
    );
  }
}

CallPartsForm.propTypes = {
  saving: PropTypes.bool,
  onSave: PropTypes.func,
  part: PropTypes.object,
  onAdd: PropTypes.func,
  onCancel: PropTypes.func,
  adding: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...modalActions }, dispatch)
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CallPartsForm);
